<template>
    <div id="contact-page">
        <div v-if="currentContactTopAd" v-on:click="handleAdClick(currentContactTopAd)" class="header-banner" style="margin-bottom: 20px;">
            <img :src="currentContactTopAd.imageBanner | optimizeBanner" alt="">
        </div>
        <div v-if="currentContactTopAd" v-on:click="handleAdClick(currentContactTopAd)" class="header-banner-mobile"  style="margin-bottom: 20px;">
            <img :src="currentContactTopAd.imageBannerMobile | optimizeBanner" alt="">
        </div>
        <div class="contact-form-wrap">
            <div class="contact-form-left">
                <div class="contact-form-left-content">
                    <div class="contact-form-title">
                        <h1>Um okkur</h1>
                    </div>
                    <div class="contact-form-text">
                        <p>Við félagar, Hafliði og Helgi stofnuðum vefsíðuna Vínleit í september árið 2020. Við erum miklir áhugamenn um vín & vínmenningu. Okkar markmið er að veita lesendum síðunnar innsýn í heim léttvínsins, fræðast um góð vín og læra að para vín með mat. Einkunnir á vefsíðunni eru í grunninn byggðar á okkar persónulega & hlutlausa mati ásamt verði vínsins. Einkunnir endurspeglast því í gæðum á móti verði. Einnig gefum við lesendum síðunnar tækifæri á að taka þátt í einkunnagjöf sem hefur áhrif á heildareinkunn léttvínanna.</p>
                    </div>
                </div>
                <div class="socials-wrap">
                    <div class="socials">
                        <img class="social-icon" onclick="window.open('https://www.facebook.com/vinleit.is')" src="../assets/social_fb_white.png" alt="">
                        <img class="social-icon" onclick="window.open('https://www.instagram.com/vinleit.is/')" src="../assets/social_in_white.png" alt="">
                    </div>
                </div>
            </div>
            <div class="contact-form-right">
                <div class="contact-form-body">
                    <h1>Sendu okkur skilaboð</h1>
                    <div class="contact-form-name">
                        <input type="text" name="name" v-model="name" placeholder="Nafn">
                    </div>
                    <div class="contact-form-email">
                        <input type="email" name="mail" v-model="email" placeholder="Email">
                    </div>
                    <div class="contact-form-message">
                        <textarea rows="5" name="comment" v-model="comment" placeholder="Athugasemd"></textarea>
                    </div>
                    <div class="contact-form-submit">
                        <input v-on:click="sendEmail()" type="button" value="Senda">
                    </div>
                    <div class="contact-form-alert">{{ alert }}</div>
                </div>
            </div>
        </div>
        <!--<h1>Vínval á samfélagsmiðlum</h1>
        
        <div class="contact-form-extras">
            <div class="contact-form-extras-col">
                <div class="contact-form-extra-card" onclick="window.open('https://www.facebook.com/Vinvalis-100737018054896/')">
                    <div class="contact-form-extra-title">Vínval á Facebook</div>
                    <div class="contact-form-extra-icon"><img src="../assets/social_fb_white.png" alt=""></div>
                </div>
            </div>
            <div class="contact-form-extras-col">
                <div class="contact-form-extra-card" onclick="window.open('https://www.instagram.com/vinval.is/')">
                    <div class="contact-form-extra-title">Vínval á Instagram</div>
                    <div class="contact-form-extra-icon"><img src="../assets/social_in_white.png" alt=""></div>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')

export default {
    data() {
        return {
            name: "",
            email: "",
            comment: "",
            alert: ""
        }
    },
    methods: {
        sendEmail() {
            if (this.name && this.email && this.comment) {
                var now = new Date().toISOString()
                fb.messagesCollection.add({
                    name: this.name,
                    email: this.email,
                    comment: this.comment,
                    read: false,
                    date: now
                })
                this.name = ""
                this.email = ""
                this.comment = ""
                this.alert = "Skilaboð send!"
            } else {
                this.alert = "Vinsamlegast fylltu í alla reiti"
            }
        },
        handleAdClick(ad) {
            window.open(ad.url)
            fb.db.collection("ads").doc(ad.id).update({
                clicks: ad.clicks + 1,
            })
        }
    },
    computed: {
        ...mapState(['currentContactTopAd'])
    },
    filters: {
        optimizeBanner: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto/')
            return newUrl
        }
    },
}
</script>

<style>
@media only screen and (max-width: 768px) {
    p {
        font-family: 'Oswald';
    }
    .contact-form-left {
        width:100%;
        padding-bottom: 20px;
    }
    .contact-form-right {
        width:100%;
    }
    .contact-form-right form {
        width:100%;
    }
    .contact-form-left-content {
        margin:20px 10px;
        display: block;
        overflow: auto;
    }
    .contact-form-body input[type="text"], input[type="email"], .contact-form-body textarea {
        width:90%;
    }
    .contact-form-submit input {
        width: 30%;
    }
    .contact-form-body {
        margin:20px;
        top: 50%;
    }
    .contact-form-title {
        
    }
    .contact-form-title h1 {
        margin:0;
        font-size: 40px;
    }
    .contact-form-text {
        text-align: justify;
        width: 90%;
        padding-top: 10px;
        padding-bottom: 20px;
        font-size: 15px;
    }
    .contact-form-extra-card {
        height:150px;
        width: 90%;
        margin:auto;
        margin-top: 25px;
        /* background-image: linear-gradient(to bottom, #bb3b3b, #c74d4f); */
        background-color: #b33b3b;
        cursor: pointer;
    }
    .contact-form-extras {
        width: 100%;
    }
}
@media only screen and (min-width: 769px) {
    .contact-form-left {
        width:50%;
        float:left;
    }
    .contact-form-right {
        width:50%;
        float:left;
    }
    .contact-form-left-content {
        margin:40px 40px;
    }
    .contact-form-wrap {
        height:460px;
    }
    .contact-form-body input[type="text"], input[type="email"], .contact-form-body textarea {
        width:90%;
    }
    .contact-form-submit input {
        width:95%;
    }
    .contact-form-body {
        margin:20px;
        margin-top: 30px;
        top: 50%;
    }
    .contact-form-text {
        width:90%;
        text-align: justify;
    }
    .contact-form-extra-card {
        height:150px;
        width: 210px;
        margin:auto;
        margin-top: 25px;
        /*background-image: linear-gradient(to bottom, #bb3b3b, #c74d4f);*/
        background-color: #b33b3b;
        cursor: pointer;
    }
    .contact-form-extras {
        width: 60%;
        margin-left: 20%;
    }
}
@media only screen and (min-width: 1200px) {

}

#contact-page {
    margin-top: 2rem;
}
.contact-form-wrap {
    width: 100%;
    background-color: #e2dad4;
}
.contact-form-left {
    height: 100%;
    position: relative;
    /*background-image: linear-gradient(to bottom right, #bb3b3b, #7a2a2c);*/
    background-color: #b33b3b;
}
.contact-form-left-content {
    color: white;
}
.contact-form-title h1 {
    font-size: 40px;
    margin-top: 0px;
    margin-bottom: 10px;
}
.contact-form-text {
    margin:0 auto;
    font-size: 16px;
}
.contact-form-body input[type="text"], input[type="email"], .contact-form-body textarea {
    font-family: 'oswald';
    border: none;
    border-radius: 10px;
    padding:10px;
    font-size: 16px;
    margin-bottom: 10px;
}
.contact-form-body input[type="text"]:focus, input[type="email"]:focus, .contact-form-body textarea:focus {
    border-radius: 10px;
    outline: none;
    box-shadow: 0 0 4px #d17076;
}
.contact-form-name {
    
}
.contact-form-email {

}
.contact-form-message textarea {
    resize: none;
}
.contact-form-submit input {
    border: none;
    border-radius: 10px;
    padding:10px;
    font-size: 16px;
    margin-bottom: 10px;
    cursor:pointer;
    background-color: #bb3b3b;
    color: white;
}
.contact-form-submit input:focus {
    outline: none;
}
.contact-form-alert {
    margin:auto;
    height: 20px;
    font-weight: bold;
    font-size: 20px;
}

.contact-form-extras {
    height:200px;
    display:flex;
    justify-content: space-evenly;
}
.contact-form-extras-col {
    width:50%;
}

.contact-form-extra-title {
    color: white;
    font-size: 20px;
    line-height: 55px;
}
.contact-form-extra-icon img {
    height:50px
}
.socials-wrap {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 45px;
}
.socials {
    position: absolute;
    width: 120px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    bottom: 10px;
}
.social-icon {
    cursor: pointer;
    width: 30px;
    margin-left: 15px;
    margin-right: 15px;
}
</style>